var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopIncreasingDecreasingMoversBySentimentPositive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "78E4C24B-2B33-407D-9DC1-80517DFC1EE6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-729.000000, -865.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Chat/Summary-Metrics-Copy-2",
    transform: "translate(729.000000, 865.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-Mask"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EEEEEE",
    x: 0,
    y: 75,
    width: 235,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#EEEEEE",
    x: 0,
    y: 24,
    width: 235,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L233,0 C234.104569,-2.02906125e-16 235,0.8954305 235,2 L235,25 L235,25 L0,25 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Rectangle",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 8,
    y: 34,
    width: 25,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 8,
    y: 84,
    width: 43,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 87,
    y: 34,
    width: 36,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 87,
    y: 84,
    width: 27,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 168,
    y: 34,
    width: 17,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 168,
    y: 84,
    width: 18,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#242C33",
    x: 8,
    y: 8,
    width: 41,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#242C33",
    x: 87,
    y: 8,
    width: 43,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#242C33",
    x: 168,
    y: 8,
    width: 27,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 50,
    width: 235,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,100 L235,100 L235,123 C235,124.104569 234.104569,125 233,125 L2,125 C0.8954305,125 1.3527075e-16,124.104569 0,123 L0,100 L0,100 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 8,
    y: 59,
    width: 37,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 8,
    y: 109,
    width: 34,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 87,
    y: 59,
    width: 36,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 87,
    y: 109,
    width: 48,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 168,
    y: 59,
    width: 21,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 168,
    y: 109,
    width: 21,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 82,
    y: 0,
    width: 1,
    height: 125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 161,
    y: 0,
    width: 1,
    height: 125
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(140.000000, 28.000000)",
    fill: "#6BBE0B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.854,10.2412 C10.581,10.2012 10.326,10.3872 10.284,10.6592 C10.185,11.3002 9.645,11.7642 9,11.7642 C8.355,11.7642 7.815,11.3002 7.716,10.6592 C7.674,10.3872 7.416,10.2012 7.146,10.2412 C6.873,10.2832 6.686,10.5392 6.728,10.8112 C6.903,11.9432 7.858,12.7642 9,12.7642 C10.142,12.7642 11.097,11.9432 11.272,10.8112 C11.314,10.5392 11.127,10.2832 10.854,10.2412",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,6 C4.448,6 4,6.448 4,7 C4,7.552 4.448,7 5,7 C5.552,7 6,7.552 6,7 C6,6.448 5.552,6 5,6",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,6 C12.448,6 12,6.448 12,7 C12,7.552 12.448,7 13,7 C13.552,7 14,7.552 14,7 C14,6.448 13.552,6 13,6",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,17 C4.589,17 1,13.411 1,9 C1,4.589 4.589,1 9,1 C13.411,1 17,4.589 17,9 C17,13.411 13.411,17 9,17 M9,0 C4.029,0 0,4.029 0,9 C0,13.971 4.029,18 9,18 C13.971,18 18,13.971 18,9 C18,4.029 13.971,0 9,0",
    id: "Fill-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(140.000000, 53.000000)",
    fill: "#6BBE0B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.854,10.2412 C10.581,10.2012 10.326,10.3872 10.284,10.6592 C10.185,11.3002 9.645,11.7642 9,11.7642 C8.355,11.7642 7.815,11.3002 7.716,10.6592 C7.674,10.3872 7.416,10.2012 7.146,10.2412 C6.873,10.2832 6.686,10.5392 6.728,10.8112 C6.903,11.9432 7.858,12.7642 9,12.7642 C10.142,12.7642 11.097,11.9432 11.272,10.8112 C11.314,10.5392 11.127,10.2832 10.854,10.2412",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,6 C4.448,6 4,6.448 4,7 C4,7.552 4.448,7 5,7 C5.552,7 6,7.552 6,7 C6,6.448 5.552,6 5,6",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,6 C12.448,6 12,6.448 12,7 C12,7.552 12.448,7 13,7 C13.552,7 14,7.552 14,7 C14,6.448 13.552,6 13,6",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,17 C4.589,17 1,13.411 1,9 C1,4.589 4.589,1 9,1 C13.411,1 17,4.589 17,9 C17,13.411 13.411,17 9,17 M9,0 C4.029,0 0,4.029 0,9 C0,13.971 4.029,18 9,18 C13.971,18 18,13.971 18,9 C18,4.029 13.971,0 9,0",
    id: "Fill-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(140.000000, 78.000000)",
    fill: "#661C42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,10.2358 C7.858,10.2358 6.903,11.0568 6.728,12.1888 C6.686,12.4618 6.873,12.7168 7.146,12.7588 C7.416,12.7988 7.674,12.6138 7.716,12.3408 C7.815,11.7008 8.355,11.2358 9,11.2358 C9.645,11.2358 10.185,11.7008 10.284,12.3408 C10.326,12.6138 10.581,12.7988 10.854,12.7588 C11.127,12.7168 11.314,12.4618 11.272,12.1888 C11.097,11.0568 10.142,10.2358 9,10.2358",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,7 C4.448,7 4,6.448 4,7 C4,7.552 4.448,8 5,8 C5.552,8 6,7.552 6,7 C6,6.448 5.552,7 5,7",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,7 C12.448,7 12,6.448 12,7 C12,7.552 12.448,8 13,8 C13.552,8 14,7.552 14,7 C14,6.448 13.552,7 13,7",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,17 C4.589,17 1,13.411 1,9 C1,4.589 4.589,1 9,1 C13.411,1 17,4.589 17,9 C17,13.411 13.411,17 9,17 M9,0 C4.029,0 0,4.029 0,9 C0,13.971 4.029,18 9,18 C13.971,18 18,13.971 18,9 C18,4.029 13.971,0 9,0",
    id: "Fill-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(140.000000, 103.000000)",
    fill: "#661C42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,10.2358 C7.858,10.2358 6.903,11.0568 6.728,12.1888 C6.686,12.4618 6.873,12.7168 7.146,12.7588 C7.416,12.7988 7.674,12.6138 7.716,12.3408 C7.815,11.7008 8.355,11.2358 9,11.2358 C9.645,11.2358 10.185,11.7008 10.284,12.3408 C10.326,12.6138 10.581,12.7988 10.854,12.7588 C11.127,12.7168 11.314,12.4618 11.272,12.1888 C11.097,11.0568 10.142,10.2358 9,10.2358",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,7 C4.448,7 4,6.448 4,7 C4,7.552 4.448,8 5,8 C5.552,8 6,7.552 6,7 C6,6.448 5.552,7 5,7",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,7 C12.448,7 12,6.448 12,7 C12,7.552 12.448,8 13,8 C13.552,8 14,7.552 14,7 C14,6.448 13.552,7 13,7",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,17 C4.589,17 1,13.411 1,9 C1,4.589 4.589,1 9,1 C13.411,1 17,4.589 17,9 C17,13.411 13.411,17 9,17 M9,0 C4.029,0 0,4.029 0,9 C0,13.971 4.029,18 9,18 C13.971,18 18,13.971 18,9 C18,4.029 13.971,0 9,0",
    id: "Fill-7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 194,
    y: 41,
    width: 31,
    height: 51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.525,44.7906331 L208.934367,50.2 L208.032099,51.1022683 L203.999633,47.0686331 L204,88 L203,88 L202.999633,47.1186331 L199.017194,51.1015611 L198.115633,50.2 L203.525,44.7906331 Z",
    id: "Combined-Shape",
    fill: "#992E65",
    transform: "translate(203.525000, 66.395317) rotate(-180.000000) translate(-203.525000, -66.395317) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.525,44.7906331 L219.934367,50.2 L219.032099,51.1022683 L214.999633,47.0686331 L215,88 L214,88 L213.999633,47.1186331 L210.017194,51.1015611 L209.115633,50.2 L214.525,44.7906331 Z",
    id: "Combined-Shape-Copy",
    fill: "#6BBE0B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIncreasingDecreasingMoversBySentimentPositive);
export default __webpack_public_path__ + "static/media/top-increasing-decreasing-movers-by-sentiment-positive.9035ff1fa5e6c1e108fa398faf5abfb2.svg";
export { ForwardRef as ReactComponent };